import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getManageBusCompanyApi } from "../../../api/busCompany";

// First, create the thunk
export const fetchManageBus = createAsyncThunk(
  "manageBus/fetchManageBus",
  async ({ query }: { query: string }) => {
    try {
      const response = await getManageBusCompanyApi(query);
      return response.data;
    } catch (error) {
      
    }
  }
);

const initialState: any = {
  isFetching: true,
  pagination: {
    total: 0,
    per_page: 10,
    current_page: 1,
    last_page: 1,
  },
  result: [],
};

export const ListBusSlice = createSlice({
  name: "manageBus",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
  },
  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder.addCase(fetchManageBus.pending, (state) => {
      state.isFetching = true;
    });

    builder.addCase(fetchManageBus.rejected, (state) => {
      state.isFetching = false;
    });

    builder.addCase(fetchManageBus.fulfilled, (state, action) => {
      state.isFetching = false;
      state.pagination = action.payload?.pagination;
      state.result = action.payload?.data;
   
    });
  },
});

export const {} = ListBusSlice.actions;

export default ListBusSlice.reducer;
